export type AiStatus = 'idle' | 'loading' | 'success' | 'error';

export interface AiGenerationState {
  status: AiStatus;
  errorMessage: string | null;
  lastPrompt: string | null;
}

export const defaultAiState: AiGenerationState = {
  status: 'idle',
  errorMessage: null,
  lastPrompt: null
};

export interface AiGenerateRequest {
  prompt: string;
  frameCount: number;
  style: string;
  apiKey: string;
  gridW: number;
  gridH: number;
}
